/**
 * @file: description
 * @author: liwenpeng
 * @Date: 2020-02-10 11:20:29
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-10 11:52:51
 */

import { BaseModule } from './imgBase';
import './imgSize.less';

class ImgSize extends BaseModule {
  public display: HTMLDivElement;

  onCreate = () => {
    // Create the container to hold the size display
    const ele = document.createElement('div');

    ele.className = 'img-tool__size';
    this.display = ele;

    // Attach it
    this.overlay.appendChild(this.display);
  };

  onUpdate = () => {
    if (!this.display || !this.img) {
      return;
    }

    const size = this.getCurrentSize();
    this.display.innerHTML = size.join(' &times; ');
  };

  getCurrentSize = () => [
    this.img.width,
    Math.round((this.img.width / this.img.naturalWidth) * this.img.naturalHeight)
  ];
}

export default ImgSize;
